import styled from 'styled-components';

// therapist notes
export const NotesContainer = styled.div`
  border-radius: 4px;
  box-shadow: rgb(0 0 0 / 8%) 0px 4px 12px;
  padding: 20px;
  margin-bottom: 25px;
`;
